/* Date related constants. */
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var CURRENT_YEAR = new Date().getFullYear();
var CURRENT_MONTH = new Date().getMonth() + 1;
var EPOCH_DATE = new Date(1970, 0, 1);
var DAYS = __spreadArray([], Array(31), true).map(function (row, index) { return index + 1; });
var MONTHS = __spreadArray([], Array(12), true).map(function (row, index) { return index; });
var YEARS = __spreadArray([], Array(21), true).map(function (row, index) { return index; });
var DAYS_OF_WEEK = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
];
var DAYS_OF_WEEK_SHORT = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
var MONTHS_SHORT = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
];
var MONTHS_LONG = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
];
var MONTHS_MAP = [
    { value: 1, displayName: 'Jan' },
    { value: 2, displayName: 'Feb' },
    { value: 3, displayName: 'Mar' },
    { value: 4, displayName: 'Apr' },
    { value: 5, displayName: 'May' },
    { value: 6, displayName: 'Jun' },
    { value: 7, displayName: 'Jul' },
    { value: 8, displayName: 'Aug' },
    { value: 9, displayName: 'Sep' },
    { value: 10, displayName: 'Oct' },
    { value: 11, displayName: 'Nov' },
    { value: 12, displayName: 'Dec' },
];
var YEARS_FULL = YEARS.map(function (year) { return CURRENT_YEAR - year; });
var MILLISECONDS_PER_DAY = 24 * 60 * 60 * 1000;
var DAYS_IN_A_WEEK = 7;
export { CURRENT_YEAR, CURRENT_MONTH, DAYS, DAYS_IN_A_WEEK, DAYS_OF_WEEK, DAYS_OF_WEEK_SHORT, EPOCH_DATE, MILLISECONDS_PER_DAY, MONTHS, MONTHS_MAP, MONTHS_SHORT, MONTHS_LONG, YEARS, YEARS_FULL, };
